export default __webpack_public_path__ + "static/media/priority.d9bc6fd1.png";